import React from "react";
import { Field, FormikProvider } from "formik";

const TextBox = ({ label, name, placeholder, credentials, value, setValue, type, choice, onChange, handleBlur, errors, getIn }) => {
  const handleInputs = (e) => {
    setValue({ ...credentials, [e.target.name]: e.target.value });
  };

  let flag = false;
  let name1, name2;
  if (name.includes(".")) {
    flag = true;
    name1 = name.split(".")[0];
    name2 = name.split(".")[1];
  }

  return (
    <div className="space-y-2">
      <label className="block text-sm font-medium text-gray-700" htmlFor={name}>
        {label}
        {!flag && errors && errors[name] && (
          <span className="text-red-500 ml-1">*</span>
        )}
        {flag && errors.address && errors.address[name2] && (
          <span className="text-red-500 ml-1">*</span>
        )}
      </label>
      <input
        name={name}
        placeholder={placeholder}
        value={value}
        type={type || "text"}
        onChange={onChange}
        onBlur={handleBlur}
        className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all duration-200 text-gray-900 placeholder-gray-500"
      />
    </div>
  );
};

export default TextBox;
